module.exports = __webpack_public_path__ + "img/arrow_qa.f5ff25f2.svg";